<div class="row">
  <app-card type="info"
    borderClass="border-default">
    <div icon-title><span class="fa fa-bookmark-o"></span></div>
    <div left-title>
      <h4 class="mb-0">Program Shortcuts</h4>
    </div>
    <div card-content-container>
      <ul class="ps-4">
        <ng-container>
          <li *ngIf="showDraft"><a  routerLink="/program/draft-documents" [attr.data-dl]="JSON.stringify({da_track: 'true'})">Draft Documents</a></li>
          <li *ngIf="showSoldProposals"><a routerLink="/program/sold-proposals" [attr.data-dl]="JSON.stringify({da_track: 'true'})">{{programShortcutsData1}}</a></li>
          <li *ngIf="showDownload"><a (click)="onPdfCellClicked()" [attr.data-dl]="JSON.stringify({da_track: 'true'})">{{programShortcutsData2}}</a></li>
        </ng-container>
      </ul>
    </div>
  </app-card>
</div>
